import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { Modal } from 'antd';
import Body from './Body/Body';
import { modalBodyStyle } from '../../../components/commentsChat/CommentsModal/constants';
import Footer from './Footer/Footer';
import deleteComment from '../../../requests/deleteRequestComment';
import { queryKeys } from '../../../queries/queryKeys';

const RequestCommentsModal = ({
  visible,
  onClose,
  request,
  comments,
  canChange = true,
}) => {
  const queryClient = useQueryClient();

  const [editedCommentData, setEditedCommentData] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleEditBtnClick = (editCommentData) => {
    setEditedCommentData(editCommentData);
  };

  const updateComments = () =>
    queryClient.invalidateQueries(queryKeys.requestComments(request.id));

  const handleDeleteComment = async (commentId) => {
    setDeleteLoading(true);
    await deleteComment(commentId);
    setDeleteLoading(false);
    updateComments();
  };

  return (
    <Modal
      width={590}
      visible={visible}
      centered={true}
      bodyStyle={modalBodyStyle}
      title={`Комментарии • ${request.id}`}
      onCancel={onClose}
      confirmLoading={deleteLoading}
      footer={
        canChange ? (
          <Footer
            requestId={request.id}
            editedCommentData={editedCommentData}
            setEditedCommentData={setEditedCommentData}
            visible={visible}
            updateData={updateComments}
            showCheckboxOptions={!editedCommentData}
          />
        ) : null
      }
    >
      <Body
        onEditBtnClick={handleEditBtnClick}
        onDeleteComment={handleDeleteComment}
        comments={comments}
        request={request}
        editedCommentData={editedCommentData}
        canChange={canChange}
      />
    </Modal>
  );
};

export default RequestCommentsModal;
